export enum RatingColors {
  DEFAULT = 'var(--ion-color-semi-light)',
  ACTIVE = 'var(--ion-color-primary)'
}
